import React from 'react'

const IconSortUpDownArrow = () => {
  return (
    <svg width="10" height="14" viewBox="0 0 10 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0.633194 5.49999L5.00007 0.633117L9.36694 5.49999L0.633194 5.49999ZM0.633194 8.49999L9.36694 8.49999L5.00007 13.3669L0.633194 8.49999ZM2.25798 9.24353L5.00007 12.2356L7.74215 9.24353L2.25798 9.24353Z" fill="#686867" />
    </svg>
  )
}

export default IconSortUpDownArrow
